export default {
  getCustomNamings(state) {
    return state.custom_namings;
  },
};
